exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3o83nwrwZcDMo2F6VIxRq7{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-size:.92857rem;height:2.5rem;margin:0;margin-bottom:-.07143rem;padding-left:1.07143rem;position:relative;text-transform:uppercase;top:-.14286rem}._2g6GlY_IEq5umh_FXqhIC5{color:hotpink}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Student_homeworkStatusText": "_3o83nwrwZcDMo2F6VIxRq7",
	"Student_hotPinkColor": "_2g6GlY_IEq5umh_FXqhIC5"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Homework/PaperBased/MarkHomeworkDayView/Student/style.postcss
// module id = 1646
// module chunks = 0